import { useUserCognitoGroups } from '@npm-client-frontends/shared-hooks'
import React, { useEffect, useRef, useState } from 'react'
import { Box, ScopedCssBaseline, ThemeProvider } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import {
  dispatch,
  Channels,
  Sources,
  Events,
} from '@npm-client-frontends/client-frontends-custom-events'
import { Header } from './components/Header'
import LeftSidebar, { drawerWidth } from './components/LeftSidebar'
import theme from './theme'
import { ExternalMenuItems, generateMenuItems } from './constants'
import { useUpdateSidebarStatusLocalStorage } from './hooks'
import { useAccessControl } from '@npm-client-frontends/shared-hooks'
import { AccessDenied } from './components/AccessDenied'
import { useLocation } from 'react-router-dom'

export default () => {
  const muiTheme = useTheme()
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'))
  const [visible, setVisible] = useState(true)
  const [expanded, setExpanded] = useState(
    localStorage.getItem('sidePanelOpen') === 'true',
  )
  const initiallyToggled = useRef(true)
  const location = useLocation()

  const MenuItems = generateMenuItems()

  useUpdateSidebarStatusLocalStorage(visible, expanded)

  const toggleVisibility = () =>
    setVisible((prev) => {
      dispatch(
        Channels.UI,
        Sources.NAV,
        !prev ? Events.SIDE_PANEL_SHOW : Events.SIDE_PANEL_HIDE,
      )
      return !prev
    })
  const toggleExpanded = () =>
    setExpanded((prev) => {
      dispatch(
        Channels.UI,
        Sources.NAV,
        !prev ? Events.SIDE_PANEL_EXPAND : Events.SIDE_PANEL_COLLAPSE,
      )
      return !prev
    })

  useEffect(() => {
    setTimeout(
      () => {
        dispatch(
          Channels.UI,
          Sources.NAV,
          isMobile ? Events.SIDE_PANEL_HIDE : Events.SIDE_PANEL_SHOW,
        )
        setVisible(!isMobile)
        initiallyToggled.current = true
      },
      initiallyToggled.current ? 0 : 1000,
    )
  }, [isMobile])

  const { userAudienceGroups } = useUserCognitoGroups()
  const { checkAccess } = useAccessControl()
  const [showAccessDenied, setShowAccessDenied] = useState(false)

  useEffect(() => {
    setShowAccessDenied(
      !checkAccess(location.pathname) && location.pathname !== '/login',
    )
  }, [location.pathname])

  return (
    <ThemeProvider theme={theme}>
      <ScopedCssBaseline>
        <Box sx={{ display: 'flex' }}>
          <Header toggleVisibility={toggleVisibility} />
          {visible && (
            <LeftSidebar
              expanded={expanded}
              toggleExpanded={toggleExpanded}
              items={{ MenuItems, ExternalMenuItems }}
              userAudienceGroups={userAudienceGroups}
            />
          )}
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              width: { sm: `calc(100% - ${drawerWidth}px)` },
            }}
          >
            <div id="main-content">{showAccessDenied && <AccessDenied />}</div>
          </Box>
        </Box>
      </ScopedCssBaseline>
    </ThemeProvider>
  )
}
